<app-base-error errorCode="404">
    <span title>Page not found</span>
    <span message>
        The page you requested does not exist. Check the address in your
        URL bar and try again.
    </span>
  </app-base-error>
  